import { useState } from "react";
import { BellRing, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { enablePush, isIOS, isStandalone, pushEnabled } from "../../lib/pwa";

/** Activa las notificaciones de este celular: promos y, si viene un pasaje, sus cambios de horario. */
export const PushOptIn = ({ code, t, testid = "push-optin", dark = false, className = "" }) => {
  const [on, setOn] = useState(() => pushEnabled(code));
  const [busy, setBusy] = useState(false);
  const needInstall = isIOS() && !isStandalone();
  const go = async () => {
    setBusy(true);
    try { await enablePush({ code, t }); setOn(true); toast.success(code ? "Listo: te avisamos al celular si cambia tu viaje y cuando haya promos" : "Listo: te avisamos al celular cuando haya promos"); }
    catch (e) { toast.error(e?.response?.data?.detail || e?.message || "No se pudieron activar los avisos"); }
    finally { setBusy(false); }
  };
  if (on) return <p data-testid={`${testid}-on`} className={`flex items-center gap-2 text-sm font-semibold ${dark ? "text-[var(--lime)]" : "text-[var(--forest)]"} ${className}`}><CheckCircle2 className="h-4 w-4" /> Avisos al celular activados</p>;
  return (
    <div className={className}>
      <button type="button" onClick={go} disabled={busy} data-testid={testid}
        className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold transition-transform duration-200 hover:scale-105 disabled:opacity-60 ${dark ? "border-2 border-[var(--lime)] text-[var(--lime)]" : "bg-[var(--forest)] text-white"}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />} {code ? "Avisame al celular si cambia mi viaje" : "Recibir promos en el celular"}
      </button>
      {needInstall && <p data-testid={`${testid}-ios-tip`} className={`mt-2 text-xs ${dark ? "text-white/80" : "text-[var(--muted-ink)]"}`}>En iPhone, primero instalá la app y abrila desde el ícono para activar los avisos.</p>}
    </div>
  );
};
